/**
 * A declaration check in words (`declarations:check.*`), wherever a check code is shown: the
 * check table of an upload, the dossier queue's "Kiểm tra chưa đạt", the review panel.
 * `SIGNATURE:<n>` is the n-th signature (or document time-stamp), `FIELD:<key>` a declared field
 * (its template label when the check carries it, else the field's name); a code the console does
 * not know stays as it is.
 *
 * Pure: `npm test` covers it (tests/check-labels.test.mjs).
 */

export type CheckLookup = (key: string, values?: Record<string, unknown>) => string | undefined;

export function checkLabelWith(code: string, detail: Record<string, unknown> | null | undefined, lookup: CheckLookup): string {
  if (code.startsWith('SIGNATURE:')) {
    const n = code.slice(10);
    return lookup(detail?.kind === 'DOCUMENT_TIMESTAMP' ? 'check.documentTimestamp' : 'check.signature', { n }) ?? code;
  }
  if (code.startsWith('FIELD:')) {
    const key = code.slice(6);
    const label = typeof detail?.label === 'string' ? detail.label : (lookup(`fieldName.${key}`) ?? key);
    return lookup('check.field', { label }) ?? code;
  }
  return lookup(`check.${code}`) ?? code;
}
